module.exports = __webpack_public_path__ + "img/repetition-icon.b6e12e1d.png";